// @ts-nocheck
import * as React from "react";

const TagLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m5.09 4 9.35.88a1 1 0 0 1 .61.29l6.42 6.41a1.82 1.82 0 0 1 0 2.57l-7.32 7.32a1.82 1.82 0 0 1-1.101.52l-.179.01a1.84 1.84 0 0 1-1.29-.53l-6.41-6.42a1 1 0 0 1-.29-.61L4 5.09a1 1 0 0 1 .206-.705l.084-.095a1 1 0 0 1 .8-.29Zm1.02 2.11.76 7.78 6 6 7.05-7.05-6-6-7.81-.73Zm5.45 3.33a1.5 1.5 0 1 1-2.12 2.12 1.5 1.5 0 0 1 2.12-2.12Z"
            />
        </svg>
    );
};

export default React.memo(TagLine);
